import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Treatment } from './Treatment';
import { useIsDesktop } from 'Hooks';

interface ITreatments {
  treatmentMethods: string[];
}

export const Treatments = ({ treatmentMethods }: ITreatments) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack gap='8px'>
      <Typography
        variant={isDesktop ? 'body2' : 'body1'}
        component='h4'
        sx={{
          cursor: 'text',
        }}
      >
        {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.treatmentMethods}
      </Typography>
      <Stack
        direction='row'
        gap='8px'
        flexWrap='wrap'
        sx={{
          pr: '24px',
        }}
      >
        {treatmentMethods.map((method: string, index: number) => {
          return <Treatment key={index} treatmentMethod={method} />;
        })}
      </Stack>
    </Stack>
  );
};
